export const viewOrderspermissions = ["PRIV_VIEW_ORDERS", "PRIV_VIEW_VAS_ORDERS", "PRIV_VIEW_VAS_PRODUCTIONS"];

export default viewOrderspermissions;